import { services } from '../services';
var action = "salepaymentschedule";

export const scheduleService = {
    custom,
    preview,
    save,
    change,
    changeInfo,
    changePayment,
    generate_change_payment
};

function custom(object) {
    return services.restApi(`${action}/custom`, 'POST', object);
}

function save(object) {
    return services.restApi(`${action}/save`, 'POST', object);
}
function generate_change_payment(object) {
    return services.restApi(`${action}/generate_change_payment`, 'POST', object);
}
function change(object) {
    return services.restApi(`${action}/changepayment`, 'POST', object);
}

function preview(id) {
    return services.restApi(`salepaymentschedule/saleschedule/${id}`, 'GET');
}
function changePayment(id) {
    return services.restApi(`salepaymentschedule/change_payment/${id}`, 'GET');
}
function changeInfo(id) {
    return services.restApi(`salepaymentschedule/changeinfo/${id}`, 'GET');
}